import getWrappedUseQuery from "api/helpers/getWrappedUseQuery";
import apiClient from "api-client";

import KEYS from "../keys";

export const getOfficeActiveForumReferences = apiClient.Offices.references.get;

export const useOfficesQuery = getWrappedUseQuery(KEYS.GET_OFFICES, apiClient.Offices.get);
